import cl from "classnames";
import styles from "./side-menu.module.scss";
import { ReactSvgComponent, StyleProps } from "@touche-lts/panel-ui/dist";
import { SectionContainer } from "@touche-lts/panel-ui/dist/components/shared/section-container";
import { SideMenuSectionButtonProps } from "@touche-lts/panel-ui/dist";
import { Button } from "@touche-lts/panel-ui/dist/components/shared/button";
import { useExpandableMenu } from "./side-menu.utils";
import { SideMenuSectionButton } from "../side-menu-section-button";
import { IconHamburger, IconClose } from "assets/icons";
import { useGetIsResponsiveScreen } from "hooks/custom-hooks";
import { useState, useCallback } from "react";

export interface SideMenuPropsUI extends StyleProps {
  iconArrowLeft?: ReactSvgComponent;
  iconArrowRight?: ReactSvgComponent;
  isUserAuthenticated?: boolean;
  navMenu?: SideMenuSectionButtonProps[];
}

const SideMenuComponent = (props: SideMenuPropsUI) => {
  const {
    className,
    style,
    iconArrowLeft: IconArrowLeft,
    iconArrowRight: IconArrowRight,
    isUserAuthenticated,
    navMenu,
  } = props;

  const { collapseMenu, expandMenu, isExpanded, setIsExpanded } =
    useExpandableMenu({
      isUserAuthenticated,
    });

  const { isResponsive: isMobile } =
    useGetIsResponsiveScreen("(max-width: 768px)");
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const closeMobileMenu = useCallback(() => setIsMobileOpen(false), []);

  return (
    <>
      {isMobile && isMobileOpen && (
        <div className={styles.overlay} onClick={closeMobileMenu} />
      )}

      <SectionContainer
        className={cl(
          styles.container,
          {
            [styles.expanded]: isExpanded,
            [styles.mobileOpen]: isMobile && isMobileOpen,
          },
          className,
        )}
        style={style}
        onMouseEnter={!isMobile ? expandMenu : undefined}
        onMouseLeave={!isMobile ? collapseMenu : undefined}
      >
        {navMenu.map((navProps, index) => (
          <SideMenuSectionButton
            key={index}
            {...navProps}
            onClick={() => {
              navProps.onClick?.();
              if (isMobile) closeMobileMenu();
            }}
          />
        ))}

        {isUserAuthenticated && !isMobile && (
          <Button
            preset="icon"
            className={styles.arrow}
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? <IconArrowLeft /> : <IconArrowRight />}
          </Button>
        )}
      </SectionContainer>

      {isMobile && (
        <Button
          preset="icon"
          className={cl(styles.mobileToggle, {
            [styles.mobileToggleOpen]: isMobileOpen,
          })}
          onClick={() => setIsMobileOpen(!isMobileOpen)}
        >
          {isMobileOpen ? (
            <IconClose width={20} height={20} />
          ) : (
            <IconHamburger width={22} height={22} />
          )}
        </Button>
      )}
    </>
  );
};

SideMenuComponent.defaultProps = {
  iconArrowLeft: () => null,
  iconArrowRight: () => null,
  isUserAuthenticated: true,
} as SideMenuPropsUI;

const SideMenuUI = SideMenuComponent;
export { SideMenuUI };
